export enum FeatureSetType {
  Website = 'website',
  Registry = 'registry',
  Rsvp = 'rsvp'
}

export type FeatureSet = {
  [Prop in FeatureSetType]?: boolean;
};
